import React from 'react';

import { ClinicActionsV2 } from 'src/dropInClinic/ClinicActionsV2';
import { LegacyClinicActions } from 'src/dropInClinic/LegacyClinicActions';
import { POP_IN_V2 } from 'src/featureFlags/currentFlags';
import { useFeatureFlag } from 'src/featureFlags/useFeatureFlag';

export const ClinicActions = ({ patientId }: { patientId: string }) => {
  const isV2Enabled = useFeatureFlag(POP_IN_V2);
  return isV2Enabled ? (
    <ClinicActionsV2 patientId={patientId} />
  ) : (
    <LegacyClinicActions patientId={patientId} />
  );
};
